export default [{
  path: '/painel-proposta',
  name: 'painel-proposta',
  component: () => import('@/app-modulo/comercial/proposta/PainelProposta.vue'),
  meta: {
    resource: 'painelproposta',
    action: 'read',
    navActiveLink: 'painel-proposta',
    pageTitle: 'Painel de Propostas',
    useButtonProposta: true,
    useButtonDashBoardComercial: true,
  },
  children: [
    {
      path: '/painel-proposta/proposta/:propostaId',
      component: () => import('@/app-modulo/comercial/cadastro-proposta/CadastroProposta.vue'),
      name: 'cadastro-proposta',
      props: route => ({ propostaIdAtual: route.params.propostaId, autoOpenModal: true }),
    },
  ],
}]
